"use client";
import Home from "./components/Home";
import Navbar from "./components/static-sections/Navbar";
import styles from "./page.module.scss";

export default function MainSite() {
  return (
    <div className={`${styles.mainContainer} ${styles.visible}`}>
      <Navbar />
      <Home />
    </div>
  );
}
